<template>
  <text-field
    dense
    :data-testid="`${toKebabCase(field.label)}-custom-field-input`"
    :required="field.required"
    v-model="value"
    v-bind="{ ...$props, ...$attrs }"
    :prepend-icon="fieldIcon"
    @keydown="handleKeydown"
    :hide-details="hideDetails ? 'auto' : false"
    :label="displayLabel ? field.label : ''"
    :placeholder="field.placeholder ?? field.label"
    :persistent-placeholder="persistentPlaceholder ? Boolean(field.placeholder) : false"
    :rules="validationRules"></text-field>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';
import { CustomFieldType, toKebabCase, upperFirst } from '@nova/core';
export default {
  mixins: [customFieldTypeMixin],
  methods: {
    toKebabCase,
    handleKeydown(e) {
      if (CustomFieldType[upperFirst(this.fieldType)] === CustomFieldType.Number) {
        if (this.disallowedNumberCharacters.includes(e.key)) {
          e.preventDefault();
        }
      }
    }
  }
};
</script>
